import React from 'react'

import { BackCaretIcon } from './icons'

// TODO: EXTEND THIS TO BE CMSABLE. AWAITING DOWN TIME IN TICKETS AND APPROVAL TO DO.
const EmbGuide = (props) => {
  return (
    <div className="embroidery__guide">
      <button onClick={() => props.toggle(false)} className="embroidery__guide__close type type--medium">
        <BackCaretIcon />
        Back to Personalize
      </button>

      <div className="embroidery__guide__inner">
        <h2 className="embroidery__guide__title large">Design a towel or robe you love.</h2>

        <div className="embroidery__guide__row">
          <h3 className="title small">Monogram</h3>
          <p className="description type">Personalize your Weezie</p>

          <div className="embroidery__guide__items">
            <h4 className="large large--script">For One</h4>

            <ul className="embroidery__guide__items__inner">
              <li className="embroidery__guide__card">
                <div className="embroidery__guide__card__frame">
                  <img src="https://cdn.shopify.com/s/files/1/0566/5465/9790/files/frame.png?v=1626282611"></img>
                </div>

                <div className="embroidery__guide__card__header">
                  <p className="type type--bold">Single Initial</p>
                  <p className="type type--medium">First or last name, or shared last</p>
                </div>

                <div className="embroidery__guide__card__content">
                  <img src="https://cdn.shopify.com/s/files/1/0566/5465/9790/files/hudson-single-inital.png?v=1629119705" />
                </div>

                <div className="embroidery__guide__card__footer">
                  <p className="type type--medium">Eg. Bianca Harley</p>
                  <p className="type type--medium type--bold">in Mercer</p>
                </div>
              </li>

              <li className="embroidery__guide__card">
                <div className="embroidery__guide__card__frame">
                  <img src="https://cdn.shopify.com/s/files/1/0566/5465/9790/files/frame.png?v=1626282611"></img>
                </div>

                <div className="embroidery__guide__card__header">
                  <p className="type type--bold">Three Initials</p>
                  <p className="type type--medium">First, Middle, Last</p>
                </div>

                <div className="embroidery__guide__card__content">
                  <img src="https://cdn.shopify.com/s/files/1/0566/5465/9790/files/tybee-three-initals.png?v=1629119952" />
                </div>

                <div className="embroidery__guide__card__footer">
                  <p className="type type--medium">Eg. Addison Grace Bates</p>
                  <p className="type type--medium type--bold">in Tybee</p>
                </div>
              </li>

              <li className="embroidery__guide__card">
                <div className="embroidery__guide__card__frame">
                  <img src="https://cdn.shopify.com/s/files/1/0566/5465/9790/files/frame.png?v=1626282611"></img>
                </div>

                <div className="embroidery__guide__card__header">
                  <p className="type type--bold">Three Initials, Center Larger</p>
                  <p className="type type--medium">First, Last, Middle</p>
                </div>

                <div className="embroidery__guide__card__content">
                  <img src="https://cdn.shopify.com/s/files/1/0019/0352/5941/files/ardley-prev.png?v=1692380226" />
                </div>

                <div className="embroidery__guide__card__footer">
                  <p className="type type--medium">Eg. Carter Daisy Everson</p>
                  <p className="type type--medium type--bold">in Ardsley</p>
                </div>
              </li>
            </ul>
          </div>

          <div className="embroidery__guide__items">
            <h4 className="large large--script">For Couples</h4>

            <ul className="embroidery__guide__items__inner">
              <li className="embroidery__guide__card">
                <div className="embroidery__guide__card__frame">
                  <img src="https://cdn.shopify.com/s/files/1/0566/5465/9790/files/frame.png?v=1626282611"></img>
                </div>

                <div className="embroidery__guide__card__header">
                  <p className="type type--bold">Two Initials</p>
                  <p className="type type--medium">Both last or first names,<br/>or one initial per towel</p>
                </div>

                <div className="embroidery__guide__card__content">
                  <img src="https://cdn.shopify.com/s/files/1/0566/5465/9790/files/sullivan-two-initals.png?v=1629119952" />
                </div>

                <div className="embroidery__guide__card__footer">
                  <p className="type type--medium">Eg. Davis Hayes Williams & Parker Bell Collins</p>
                  <p className="type type--medium type--bold">in Sullivan</p>
                </div>
              </li>

              <li className="embroidery__guide__card">
                <div className="embroidery__guide__card__frame">
                  <img src="https://cdn.shopify.com/s/files/1/0566/5465/9790/files/frame.png?v=1626282611"></img>
                </div>

                <div className="embroidery__guide__card__header">
                  <p className="type type--bold">Three Initials, center larger</p>
                  <p className="type type--medium">One first, shared last, other first</p>
                </div>

                <div className="embroidery__guide__card__content">
                  <img src="https://cdn.shopify.com/s/files/1/0566/5465/9790/files/perry-three-initals-center.png?v=1629119952" />
                </div>

                <div className="embroidery__guide__card__footer">
                  <p className="type type--medium">Eg. Justine Taylor Miller & Luke Wallace Miller</p>
                  <p className="type type--medium type--bold">in Perry</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="embroidery__guide__row">
          <h3 className="title small">Embroider anything!</h3>
          <p className="description type">Embroider anything that makes you smile, the options are endless!</p>

          <div className="embroidery__guide__items">
            <ul className="embroidery__guide__items__inner">
              <li className="embroidery__guide__card">
                <div className="embroidery__guide__card__frame">
                  <img src="https://cdn.shopify.com/s/files/1/0566/5465/9790/files/frame.png?v=1626282611"></img>
                </div>

                <div className="embroidery__guide__card__header">
                  <p className="type type--bold">Titles or labels</p>
                </div>

                <div className="embroidery__guide__card__content">
                  <img src="https://cdn.shopify.com/s/files/1/0566/5465/9790/files/waverly-titles-or-labels.png?v=1629119952" />
                </div>

                <div className="embroidery__guide__card__footer">
                  <p className="type type--medium">Guest</p>
                  <p className="type type--medium type--bold">in Waverly</p>
                </div>
              </li>

              <li className="embroidery__guide__card">
                <div className="embroidery__guide__card__frame">
                  <img src="https://cdn.shopify.com/s/files/1/0566/5465/9790/files/frame.png?v=1626282611"></img>
                </div>

                <div className="embroidery__guide__card__header">
                  <p className="type type--bold">Notes or slang</p>
                </div>

                <div className="embroidery__guide__card__content">
                  <img src="https://cdn.shopify.com/s/files/1/0566/5465/9790/files/sullivan-notes-or-slang.png?v=1629119952" />
                </div>

                <div className="embroidery__guide__card__footer">
                  <p className="type type--medium">Hugs & Kisses</p>
                  <p className="type type--medium type--bold">in Sullivan</p>
                </div>
              </li>

              <li className="embroidery__guide__card">
                <div className="embroidery__guide__card__frame">
                  <img src="https://cdn.shopify.com/s/files/1/0566/5465/9790/files/frame.png?v=1626282611"></img>
                </div>

                <div className="embroidery__guide__card__header">
                  <p className="type type--bold">Names, places & things!</p>
                </div>

                <div className="embroidery__guide__card__content">
                  <img src="https://cdn.shopify.com/s/files/1/0566/5465/9790/files/river-names-places-things.png?v=1629119952" />
                </div>

                <div className="embroidery__guide__card__footer">
                  <p className="type type--medium">Lake House</p>
                  <p className="type type--medium type--bold">in River</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <button onClick={() => props.toggle(false)} className="btn btn--navy">Back to Personalize</button>
      </div>
    </div>
  )
}

export default EmbGuide
